export const isBlank = function (param) {
  if (param === '' || param === null || param === 'undefined' || typeof param === 'undefined') {
    return true
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/utils/is_blank.js